import { Monitor } from "lucide-react";
import { RetroWindow } from "./RetroWindow";
import { SERVER_HOST, SERVER_PORT } from "../../lib/api";
import { useI18n } from "../../lib/i18n";

const Row = ({ label, children, testid }) => (
  <div className="flex items-center gap-3">
    <span className="w-28 shrink-0">{label}:</span>
    <span data-testid={testid} className="w98-sunken bg-white px-2 py-1 flex-1 min-w-0 truncate">{children}</span>
  </div>
);

export const RetroStatus = ({ status, stats, loading, refresh, className }) => {
  const { t } = useI18n();
  const online = status?.online;
  const label = t(status == null ? "CHECKING" : online ? "ONLINE" : "OFFLINE");
  const bars = online ? Math.max(1, Math.min(12, Math.round(12 - status.latency_ms / 40))) : 0;
  return (
    <RetroWindow id="status" testid="server-status-card" className={className} title={t("rtStatusT")} icon={<Monitor className="h-4 w-4" />}
      statusbar={<p data-testid="server-flap-info">{t(status?.flap_hello ? "flapOk" : online ? "flapWait" : "flapNone")}</p>}>
      <div className="space-y-2.5">
        <Row label={t("stStatus")} testid="server-status-label">
          <span className={`inline-block h-3 w-3 mr-2 align-middle ${online ? "bg-[#00c000]" : online === false ? "bg-[#ff0000]" : "bg-[#ffd800]"}`} />
          <b className={online ? "text-[#008000]" : "text-[#c00000]"}>{label}</b>
        </Row>
        <Row label={t("stHost")} testid="server-host">{SERVER_HOST}</Row>
        <Row label={t("stPort")} testid="server-port">{SERVER_PORT}</Row>
        <Row label={t("stLatency")} testid="server-latency">{online ? `${status.latency_ms} ${t("ms")}` : "—"}</Row>
        <Row label={t("rtUins")} testid="stats-registered">{stats?.registered_via_site ?? "—"}</Row>
        <div className="flex items-center gap-3">
          <span className="w-28 shrink-0">{t("rtSignal")}:</span>
          <div data-testid="server-signal" className="w98-sunken bg-white flex-1 h-6 p-[3px] flex gap-[2px] overflow-hidden">
            {Array.from({ length: bars }).map((_, i) => <span key={i} className="w98-block" />)}
          </div>
        </div>
      </div>
      <div className="mt-4 flex justify-end">
        <button type="button" onClick={refresh} disabled={loading} className="w98-btn" data-testid="status-refresh-btn">{t("stPing")}</button>
      </div>
    </RetroWindow>
  );
};
